import { render, staticRenderFns } from "./uni-popup-share.vue?vue&type=template&id=f9f3cc66"
import script from "./uni-popup-share.vue?vue&type=script&lang=js"
export * from "./uni-popup-share.vue?vue&type=script&lang=js"
import style0 from "./uni-popup-share.vue?vue&type=style&index=0&id=f9f3cc66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports